import React from 'react';
import { Badge } from '../UI';

/** Paying (live Stripe subscription) vs free access (marked paid without one, e.g. tutors) vs free. */
export const AccessBadge: React.FC<{ plan: string; paying?: boolean }> = ({ plan, paying }) => {
  if (paying) return <Badge tone="paid">Paying</Badge>;
  const marked = plan && plan !== 'free';
  if (marked && paying === false) return <Badge tone="school">Free access</Badge>;
  if (marked) return <Badge tone="paid">{plan.replace(/^\w/, (c) => c.toUpperCase())}</Badge>;
  return <Badge tone="free">Free</Badge>;
};
